<template>
  <div id="index">
    <Header ref="header"></Header>

    <div class="offerList" :class="morenDiv == false ? 'none':''" style="margin:20px auto">
      <div class="offerListBox">
        <div class="dynamicsCon">
          <h5>
            <b>药材拼音：</b>
            <span v-for="(item,index) in letterList" :key="index" :class="letterClass == index ? 'letterActive':''" @click="selectLetter(index,item.letter)">{{item.letter}}</span>
          </h5>
          <h6><a v-for="item in groupList" :key="item.index" @click="selectYcnam(item.ycnam)">{{item.ycnam}}</a></h6>
        </div>
        <div class="dynamicsData">
          <h5>区　　域：<a v-for="(item,index) in marketList" :key="index" :class="marketClass == index ? 'marketActive':''" @click="selectMarket(index,item.market)">{{item.name}}</a></h5>
          <table>
            <thead>
              <td>品种</td>
              <td>规格</td>
              <td>产地</td>
              <td>价格(1kg)</td>
              <td>走势</td>
              <td>市场</td>
              <!-- <td @click="changeData(marketClass,'yesterday','yesterdayZhangLuo',change1)">昨日对比 <img v-show="showDyTop" src="../assets/img/dynamicsTop.png" ><img v-show="showDyDown" src="../assets/img/dynamicsDown.png" ></td> -->
              <td @click="changeData(marketClass,'yesterday','yesterdayZhangLuo',change1)">昨日对比</td>
              <td @click="changeData(marketClass,'zhouduibi','zhouduibiZhangLuo',change1)">周对比</td>
              <td @click="changeData(marketClass,'yueduibi','yueduibiZhangLuo',change1)">月对比</td>
              <td @click="changeData(marketClass,'jiduibi','jiduibiZhangLuo',change1)">季对比</td>
              <td @click="changeData(marketClass,'nianduibi','nianduibiZhangLuo',change1)">年对比</td>
            </thead>
            <tr v-for="item in dynamicsList" :key="item.id">
              <td>{{item.ycnam}}</td>
              <td>{{item.guige}}</td>
              <td>{{item.chandi}}</td>
              <td>{{item.pri}}</td>
              <td>{{item.zoushi}}</td>
              <td>{{item.shichang}}</td>
              <td><a :style="item.yesterday > 0 ? 'color:#AF2423':'color:#1BBD3B'">{{item.yesterday}}</a></td>
              <td><a :style="item.zhouduibi > 0 ? 'color:#AF2423':'color:#1BBD3B'">{{item.zhouduibi}}</a></td>
              <td><a :style="item.yueduibi > 0 ? 'color:#AF2423':'color:#1BBD3B'">{{item.yueduibi}}</a></td>
              <td><a :style="item.jiduibi > 0 ? 'color:#AF2423':'color:#1BBD3B'">{{item.jiduibi}}</a></td>
              <td><a :style="item.nianduibi > 0 ? 'color:#AF2423':'color:#1BBD3B'">{{item.nianduibi}}</a></td>
            </tr>
          </table>
        </div>
        <el-pagination background layout="prev, pager, next" :currentPage="currentPage" :pageSize ="pageSize" :total="totalNum"  @size-change="handleSizeChange" @current-change="handleCurrentChange"></el-pagination>
      </div>
    </div>
    <div style="width:100%;height:200px"></div>

    <!-- 底部 -->
    <div class="footer">
      <div class="foot">
        <ul>
         <li>电话：0558-5858131</li>
          <li>地址：亳州市谯城区亳芜现代产业园区希夷大道与月季路交叉口</li>
          <li>安徽广盛堂中药饮片有限公司 版权所有 免责声明 皖ICP备18026442号</li>
          <li>皖公网安备 3416020200060号</li>
        </ul>
        <img src="../assets/img/footerImg.jpg" alt="">
      </div>
    </div>
  </div>
</template>
<script>
import Header from '../components/header'
export default {
  components: {
    Header
  },
  data() {
    return {
      morenDiv:true,
      showLogin:true,
      EWMImg:false,
      EWMButton:true,
      currentPage: 1,//默认显示第一页
      pageSize:10,//默认每页显示10条
      totalNum: 100, //总页数
      letterClass:0,
      marketClass:0,
      letterList:[
        {letter:'全部'},
        {letter:'A'},
        {letter:'B'},
        {letter:'C'},
        {letter:'D'},
        {letter:'E'},
        {letter:'F'},
        {letter:'G'},
        {letter:'H'},
        {letter:'I'},
        {letter:'J'},
        {letter:'K'},
        {letter:'L'},
        {letter:'M'},
        {letter:'N'},
        {letter:'O'},
        {letter:'P'},
        {letter:'Q'},
        {letter:'R'},
        {letter:'S'},
        {letter:'T'},
        {letter:'U'},
        {letter:'V'},
        {letter:'W'},
        {letter:'X'},
        {letter:'Y'},
        {letter:'Z'},
      ],
      marketList:[
        {name:'全部',market:0},
        {name:'亳州药市',market:1},
        {name:'安国药市',market:2},
        {name:'玉林药市',market:3},
        {name:'荷花池药市',market:4},
      ],
      groupList:[],
      dynamicsList:[],
      change1:'zhang',
      Ycnam:'',
      market:'',
      firstLetter:''
    }
  },
  mounted() {
    if(this.$cookie.get('account') == null){
      this.showLogin = true
    }else{
      this.showLogin = false
    }
    this.getDynamicsList();
    // this.selectLetter();
  },
  methods: {
    selectLetter(index,data){
      this.letterClass = index;
      if(data == '全部'){data = '';this.letterClass = 0}
      this.groupList = [];
      this.ycnam = '';
      this.firstLetter = data;
      this.currentPage= 1;
      this.getDynamicsList();
      this.$fetch('getSCGroupList',{firstLetter:data}).then(res => {
        this.groupList = res.result;
      })
    },
    //切换市场
    selectMarket(index,data){
      this.marketClass = index
      if(data == 0){
        this.market = ''
      }
      else{
        this.market = data;
      }
      this.changeData(index,'')
    },
    // 默认请求列表
    getDynamicsList(){
      this.$fetch('getDynamicsList',{market:this.market,firstLetter:this.firstLetter,pageNo:this.currentPage,pageSize:this.pageSize}).then(res => {
       this.dynamicsList = res.result.records;
       this.totalNum = res.result.total;
      })
    },
    selectYcnam(name){
      this.Ycnam = name;
      this.$fetch('getDynamicsList',{market:this.market,pageNo:this.currentPage,pageSize:this.pageSize,ycnam:this.Ycnam}).then(res => {
       this.dynamicsList = res.result.records;
      })
    },
    changeData(num,duibi,time,change){
      var changea = '';
      if(this.$cookie.get('change')  == 'zhang'){
        changea = 'luo'
        this.$cookie.set('change',changea)
      }else{
        changea = 'zhang'
        this.$cookie.set('change',changea)
      }
      if(num == 0){num = ''}
      this.$fetch('getDynamicsList',{market:num,paramName:duibi,[time]:changea,pageNo:this.currentPage,pageSize:this.pageSize,ycnam:this.Ycnam}).then(res => {
       this.dynamicsList = res.result.records;
      })
    },
    handleSizeChange(val) {
      this.pageSize = val;    //动态改变
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getDynamicsList()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/dynamicsList.vue